export * from './shelf-and-bin.component'